import { Location } from 'iconsax-react';
import { Link } from 'react-router-dom';
import img from '../../../../assets/images/not-photo.png';
import Text from '../../../../assets/styles/Text';
import CustomMidia from '../../../../components/CustomMidia';
import Loader from '../../../../components/Loader';
import { useClientStatus } from '../../../../hooks/queries/useClients';
import { useStore } from '../../../../stores';
import * as styles from './styles';

export default function CollumnLeft() {
  const { id } = useStore((state) => state.user);
  const { data: client = {}, isLoading: isLoadingClient } = useClientStatus(id);

  function renderClientFollowing() {
    const isEmpty = client?.following.length <= 0;

    if (isEmpty) {
      return <Text.Span>Sem modelos seguidas</Text.Span>;
    }

    return (
      <>
        {client?.following?.data?.map(({ model }) => (
          <Link to={`/model/${model.id}`} key={model.id}>
            <styles.Model>
              <img
                src={model.modelVerification.profilePhotoUrl || img}
                alt="perfil"
              />

              <div>
                <Text.H4 $bold>{model.fantasyName}</Text.H4>

                <Text.Span>
                  <Location size={20} />
                  {model.city.name} - {model.city.stateAc}
                </Text.Span>
              </div>
            </styles.Model>
          </Link>
        ))}

        {client?.following?.hasMore && (
          <Link to="/followers" className="button">
            <Text.Span $bold>Ver mais</Text.Span>
          </Link>
        )}
      </>
    );
  }

  function renderClientLikes() {
    const isEmpty = client?.likes.length <= 0;

    if (isEmpty) {
      return <Text.Span>Sem likes</Text.Span>;
    }

    return (
      <>
        <styles.Wrap>
          {client?.likes?.data?.map(({ media }, index) => (
            <CustomMidia
              key={media.id}
              midia={{ url: media.presignedUrl, mediaType: media.mediaType }}
              isImg={media.mediaType === 'photo'}
              index={index}
              total={client?.likes?.showing}
            />
          ))}
        </styles.Wrap>

        {client?.likes?.hasMore && (
          <Link to="/followers" className="button">
            <Text.Span $bold>Ver mais</Text.Span>
          </Link>
        )}
      </>
    );
  }

  return (
    <styles.Container>
      <styles.Group>
        <Text.H1>Seguindo ({client.totalFollowing})</Text.H1>

        {isLoadingClient ? (
          <Loader isLoading minimal />
        ) : (
          renderClientFollowing()
        )}
      </styles.Group>

      <styles.Group>
        <Text.H1>Curtidas ({client.totalLikes})</Text.H1>

        {isLoadingClient ? <Loader isLoading minimal /> : renderClientLikes()}
      </styles.Group>
    </styles.Container>
  );
}
